import { RequestService } from "../../../../common/services/RequestService";
import { DELETE_NIGHT_PLACEMENT } from "./constants";

export const deletePlacementRequest = async (orderId, placementId) => {
  const response = await RequestService.delete(
    DELETE_NIGHT_PLACEMENT.replace("{order_id}", orderId).replace(
      "{kids_night_list_id}",
      placementId
    )
  );
  return response;
};
